import React from "react";
import { makeStyles } from '@material-ui/styles';

import Scroller from "../scroller.js.jsx";

import martineSchrey from "../../resources/images/managers/martine_schrey.jpg";
import emmanuelGregory from "../../resources/images/managers/emmanuel_gregory.png";
import melissaEvrin from "../../resources/images/managers/melissa_evrin.png";

import Container from "../../../../../base/components/container.js";
import I18n from "../../../../../base/i18n.js.jsx";

import ManagerCard from "./manager_card.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grayBg,
  },
  textContainer: {
    padding: "55px 16px 36px",
    ['@media (max-width: 768px)']: {
      padding: "28px 24px 15px",
    },
  },
  title: {
    fontSize: "38px",
    textTransform: "uppercase",
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      lineHeight: "26px",
    },
  },
  sliderContainer: {
    padding: "0px 16px 66px",
    ['@media (max-width: 768px)']: {
      padding: "0px 24px 40px",
    },
  },
  sliderList: {
    textAlign: "center",
    margin: "0px -13px",
    ['@media (max-width: 768px)']: {
      margin: "0px -4px",
    },
  },
  sliderItem: {
    display: "inline-block",
    width: "283px",
    ['@media (max-width: 1200px)']: {
      width: "238px"
    },
    ['@media (max-width: 768px)']: {
      width: "auto"
    },
  }
}));

const ManagersBlock = () => {
  const classes = blockStyles();
  const managers = I18n.t("web.page.index.your_managers.managers");

  managers[0].image = martineSchrey;
  managers[1].image = emmanuelGregory;
  managers[2].image = melissaEvrin;

  return (
    <div className = { classes.root } >
      <Container className = { classes.textContainer } >
        <span className = { classes.title } >
          { I18n.t("web.page.index.your_managers.title") }
        </span>
      </Container>
      <Container className = { classes.sliderContainer } >
        <Scroller className = { classes.sliderList } >
          {
            managers.map((manager, index) => {
              return <div className = { classes.sliderItem }
                          key = { index }>
                <ManagerCard manager = { manager } />
              </div>
            })
          }
        </Scroller>
      </Container>
    </div>
  );
}

export default ManagersBlock;
